module.exports = __webpack_public_path__ + "img/piggy-bank-women.06254ea.webp";